import { SubscriptionType } from '../components/container/Container';
import { BenefitProps } from '../components/welcome/benefits/Benefits';
import env from '../config/env';
import FullSizeDesktop from '../assets/images/benefits/desktop/fullsize.jpg';
import OpenBoxDesktop from '../assets/images/benefits/desktop/openbox.jpg';
import ReFillsDesktop from '../assets/images/benefits/desktop/refills.jpg';
import FullSizeMobile from '../assets/images/benefits/mobile/fullsize.jpg';
import OpenBoxMobile from '../assets/images/benefits/mobile/openbox.jpg';
import ReFillsMobile from '../assets/images/benefits/mobile/refills.jpg';

interface GetBenefitsProps {
  isDesktop: boolean;
  subscriptionType?: SubscriptionType;
}

const getBenefits = ({ isDesktop }: GetBenefitsProps): BenefitProps[] => {
  return [
    {
      image: isDesktop ? OpenBoxDesktop : OpenBoxMobile,
      altImage: 'Full size product benefit',
      description: 'Year-round sales with hundreds of top brands up to 70% off',
      ctaText: 'SHOP NOW',
      ctaLink: `${env.SITE_URL}/shop`,
    },
    {
      image: isDesktop ? ReFillsDesktop : ReFillsMobile,
      altImage: 'Refills products benefit',
      description: "Discover your favorite products and brands that you didn't know you needed",
      ctaText: 'SURPRISE ME!',
      ctaLink: 'https://talk.fabfitfun.com/',
    },
    {
      image: isDesktop ? FullSizeDesktop : FullSizeMobile,
      altImage: 'Customizable box benefit',
      description: 'Customizable box with full-sized products valued up to $350',
      ctaText: 'EXPLORE NOW',
      ctaLink: `${env.SITE_URL}/customize`,
    },
  ];
};

export default getBenefits;
